import { useEffect } from 'react';
import WhatYouWillNeedView from './components/WhatYouWillNeedView';

import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { postVerificationUserInit } from 'services/api-verification-actions';
import { useGetProfileQuery } from 'store/slices/profile-api';

export const Route = createFileRoute(
  '/_authenticated/verification/what-you-will-need',
)({
  component: WhatYouWillNeed,
});

function WhatYouWillNeed() {
  const { data: profile } = useGetProfileQuery();
  const navigate = useNavigate();

  useEffect(() => {
    if (profile && profile.id) {
      postVerificationUserInit(profile.id);
    }
  }, []);

  return (
    <WhatYouWillNeedView
      onComplete={() => navigate({ to: '/verification/intent' })}
    />
  );
}

export default WhatYouWillNeed;
